import { LazyLoader } from '@bp/ui-components';
import { graphql } from 'client/gql';
import { BpPage } from 'components/BpPage/BpPage';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useQuery } from 'urql';
import { MatrixChat } from '../../components/MatrixChat/MatrixChat';
import { getMatrixRoomIdWithServerName } from '../../utils/matrixRoomId';

export const MessagesPageDocument = graphql(`
    query MessagesPageData($organizationUuids: [ID!]!) {
    ...UseDMRoomsFields
  }
`);

export function MessagesPage() {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();

  const { roomId } = useParams();

  const [matrixRoomId, setMatrixRoomId] = useState<string>();

  const [{ data }] = useQuery({
    query: MessagesPageDocument,
    variables: {
      organizationUuids: [pimAuthClaims.getOrganization().uuid],
    },
  });

  useEffect(() => {
    if (roomId) {
      getMatrixRoomIdWithServerName(roomId).then((_matrixRoomId) => {
        if (_matrixRoomId) {
          setMatrixRoomId(_matrixRoomId);
        }
      });
    }
  }, [roomId]);

  return (
    <BpPage
      title={t('messages.title', { count: 2 })}
      isForbidden={false}
      organization={pimAuthClaims.getOrganization()}
    >
      <Suspense fallback={<LazyLoader embedded transparent />}>
        <MatrixChat matrixRoomId={matrixRoomId} query={data} />
      </Suspense>
    </BpPage>
  );
}
